import { createContext, useContext } from 'react';
import { noop } from '../utils';
export var defaultContext = {
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop,
  onAdd: noop,
  onInitialItemChange: noop,
  onMenuItemClick: noop,
  setItem: noop
};
export var TypeaheadContext = /*#__PURE__*/createContext(defaultContext);
export var useTypeaheadContext = function useTypeaheadContext() {
  return useContext(TypeaheadContext);
};